/* eslint-disable jira/import-whitelist */
import { AtlBrowserStorageLocal } from '@atlassian/browser-storage-controls/web-storage-service';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import { NAVIGATION_UI_STORAGE_KEY, LOGGER_LOCATION } from './navigationUiStorageKey.constants.tsx';
import type { UIControllerShape } from './UIControllerShape.types.tsx';

const queryLocalStorageSync = (): UIControllerShape | undefined => {
	const item = AtlBrowserStorageLocal.getItem(NAVIGATION_UI_STORAGE_KEY);

	if (!__SERVER__ && item) {
		try {
			return JSON.parse(item);
			// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (e: any) {
			log.safeErrorWithoutCustomerData(LOGGER_LOCATION, 'Fail to parse sync local storage data', e);
		}
	}
};

export const queryLocalStorage = (): Promise<UIControllerShape | undefined> =>
	new Promise((resolve) => {
		const item = queryLocalStorageSync();
		resolve(item);
	});

export const updateLocalStorageData = (data: UIControllerShape): void => {
	// @browser-storage setter
	AtlBrowserStorageLocal.setStrictlyNecessaryItem(NAVIGATION_UI_STORAGE_KEY, JSON.stringify(data));
};
